import React, { useState } from 'react';
import { Stepper } from '@operations/shared';
import ViewUnidentifiedCollections from './ViewUnidentifiedCollections';
import AssignUnidentifiedCollection from './AssignUnidentifiedCollection';
import SelectUserOrCompany from '../createEarlyPayment/selectUserOrCompany';

export default function ViewAndAssignUnidentifiedCollection() {
    const [isCompany, setIsCompanyState] = useState<boolean>(true);
    const [identifier, setIdentifier] = useState<any>(null);

    const componentSteps = [
        {
            title: 'View Unidentified Collections',
            content: <ViewUnidentifiedCollections setIsCompany={setIsCompanyState} />,
            id: 0,
        },
        {
            title: 'Select Company / User to assign',
            content: <SelectUserOrCompany isCompany={isCompany} setIsCompany={setIsCompanyState} setIdentifier={setIdentifier} nextStep={2} />,
            id: 1,
        },
        {
            title: 'Assign Unidentified Collection',
            content: <AssignUnidentifiedCollection identifier={identifier} isCompany={isCompany} setIsCompany={setIsCompanyState} />,
            id: 2,
        },
    ];

    return (
        <>
            <Stepper componentSteps={componentSteps} />
        </>
    );
};

